export const gamesData = [
  {
    id: 1,
    slug: 'savanna-warriors',
    title: 'Savanna Warriors',
    tagline: 'Epic RPG set in the Serengeti',
    description: 'Embark on an epic journey through the vast Serengeti plains as a legendary Maasai warrior. Battle mythical creatures, forge alliances with tribal nations, and uncover the ancient secrets that threaten to destroy the African savanna. With stunning open-world exploration and deep combat mechanics, Savanna Warriors redefines what African RPGs can be.',
    longDescription: `In the heart of East Africa, where the golden grasslands stretch to the horizon and ancient spirits still walk the earth, a darkness stirs. You are Olekina, the last of the Shadow Warriors, destined to protect the balance between the mortal realm and the spirit world.

Features:
• Open world exploration across 100+ square kilometers of authentic African landscapes
• Deep combat system inspired by traditional Maasai warrior techniques
• Companion system with 12 unique characters from different African cultures
• Day/night cycle affecting gameplay, wildlife, and spirit encounters
• Branching storyline with multiple endings
• Original soundtrack featuring traditional African instruments`,
    image: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
    coverImage: '/images/games/savanna-warriors-cover.jpg',
    screenshots: [
      '/images/games/savanna-warriors-1.jpg',
      '/images/games/savanna-warriors-2.jpg',
      '/images/games/savanna-warriors-3.jpg',
    ],
    platforms: ['pc', 'playstation', 'xbox'],
    genres: ['RPG', 'Action', 'Open World'],
    status: 'Coming Soon',
    releaseDate: 'Q4 2025',
    rating: null,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
    trailer: 'https://youtube.com/watch?v=example',
  },
  {
    id: 2,
    slug: 'kilimanjaro-quest',
    title: 'Kilimanjaro Quest',
    tagline: 'Climb the roof of Africa',
    description: 'Scale the mighty Mount Kilimanjaro in this breathtaking adventure game. Navigate treacherous paths, manage your resources, and experience the rich culture of the Chagga people as you attempt to reach the summit of Africa\'s highest peak.',
    longDescription: `Kilimanjaro Quest takes you on the adventure of a lifetime. Starting from the lush rainforests at the mountain's base, you'll climb through five distinct ecological zones, each with unique challenges, wildlife, and cultural encounters.

Meet local guides, learn about the Chagga people's traditions, and test your survival skills against altitude sickness, unpredictable weather, and the mountain's many secrets.

Features:
• Realistic climbing simulation with altitude effects
• 5 distinct biomes with unique gameplay mechanics
• Resource management and survival elements
• Cultural storytelling through encounters with local communities
• Multiple routes to the summit, each with different challenges
• Photo mode to capture stunning African vistas`,
    image: 'linear-gradient(135deg, #00d4aa 0%, #00a86b 100%)',
    platforms: ['android', 'ios'],
    genres: ['Adventure', 'Simulation', 'Survival'],
    status: 'In Development',
    releaseDate: 'Q2 2025',
    rating: null,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
  },
  {
    id: 3,
    slug: 'swahili-legends',
    title: 'Swahili Legends',
    tagline: 'Coastal tales of ancient heroes',
    description: 'Dive into the rich mythology of the Swahili coast. Play as legendary heroes from East African folklore, battling djinns, sea monsters, and ancient curses in this action-packed adventure.',
    longDescription: `The Swahili coast holds secrets older than memory. From the ancient ports of Kilwa to the mysterious ruins of Gedi, players will uncover a world where African and Arabian mythologies intertwine.

Play as multiple characters from Swahili folklore, each with unique abilities and storylines that eventually converge in an epic battle against the rising darkness.

Features:
• Multiple playable characters from Swahili mythology
• Combat system inspired by traditional coastal martial arts
• Exploration of historically accurate Swahili architecture
• Puzzle-solving using ancient astronomical knowledge
• Co-op multiplayer for story missions
• Authentic Swahili voice acting and soundtrack`,
    image: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
    platforms: ['html5', 'android', 'ios'],
    genres: ['Action', 'Adventure', 'Mythology'],
    status: 'Beta',
    releaseDate: 'Q1 2025',
    rating: 4.5,
    players: '1-4 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
  },
  {
    id: 4,
    slug: 'zanzibar-mysteries',
    title: 'Zanzibar Mysteries',
    tagline: 'Solve puzzles in Stone Town',
    description: 'Explore the winding streets of Stone Town in this immersive VR detective experience. Solve crimes, uncover conspiracies, and experience the rich history of Zanzibar like never before.',
    longDescription: `Step into the shoes of Detective Amara Hassan in this groundbreaking VR mystery game. The historic Stone Town of Zanzibar becomes your playground as you investigate a series of mysterious disappearances linked to the island's colonial past.

Using cutting-edge VR technology, explore every corner of the UNESCO World Heritage site, interact with locals, and piece together clues in this atmospheric thriller.

Features:
• Fully immersive VR experience of historic Stone Town
• Non-linear investigation with multiple solutions
• Interactive NPCs with dynamic conversation system
• Historical accuracy vetted by Zanzibari historians
• Environmental storytelling through detailed architecture
• Multiple difficulty levels for puzzle complexity`,
    image: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
    platforms: ['vr', 'pc'],
    genres: ['Mystery', 'Adventure', 'VR'],
    status: 'Announced',
    releaseDate: '2026',
    rating: null,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
  },
  {
    id: 5,
    slug: 'maasai-runners',
    title: 'Maasai Runners',
    tagline: 'Endless runner through the plains',
    description: 'Run, jump, and slide through the beautiful African savanna in this addictive endless runner. Collect traditional artifacts, unlock new characters, and compete with friends globally.',
    longDescription: `Maasai Runners brings the spirit of the African plains to your fingertips. As a young Maasai warrior completing your coming-of-age journey, run across ever-changing landscapes from dawn to dusk.

With procedurally generated terrain, no two runs are ever the same. Encounter wildlife, overcome obstacles, and prove your worth as a true warrior of the plains.

Features:
• Stunning procedurally generated African landscapes
• 20+ unlockable characters from different African cultures
• Daily challenges and seasonal events
• Global leaderboards and friend competitions
• Authentic African music that responds to gameplay
• Collectible artifacts with educational content about African cultures`,
    image: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
    platforms: ['android', 'ios', 'html5'],
    genres: ['Endless Runner', 'Casual', 'Action'],
    status: 'Available Now',
    releaseDate: 'Released 2024',
    rating: 4.7,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
    downloads: '500K+',
  },
  {
    id: 6,
    slug: 'ngorongoro-tactics',
    title: 'Ngorongoro Tactics',
    tagline: 'Strategy game of wildlife conservation',
    description: 'Lead a wildlife conservation effort in the Ngorongoro Crater. Balance ecology, tourism, and local communities in this deep strategy simulation inspired by real conservation challenges.',
    longDescription: `Ngorongoro Tactics puts you in charge of one of Africa's most precious ecosystems. As the new director of the Ngorongoro Conservation Area, every decision you make impacts the delicate balance between wildlife, environment, and human communities.

This is not just a game—it's a simulation based on real conservation data and challenges faced by wildlife managers across Africa.

Features:
• Realistic ecosystem simulation with 50+ animal species
• Economic management balancing tourism and conservation
• Community relations system with local Maasai populations
• Climate change scenarios based on scientific projections
• Educational content developed with conservation experts
• Scenario editor for custom challenges`,
    image: 'linear-gradient(135deg, #f39c12 0%, #d35400 100%)',
    platforms: ['pc', 'xbox'],
    genres: ['Strategy', 'Simulation', 'Management'],
    status: 'Early Access',
    releaseDate: 'Early Access 2024',
    rating: 4.3,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
  },
  {
    id: 7,
    slug: 'drums-of-war',
    title: 'Drums of War: Kingdoms',
    tagline: 'Build your African empire',
    description: 'From the great kingdoms of West Africa to the empires of the East, build, expand, and defend your civilization in this epic real-time strategy game.',
    longDescription: `Drums of War: Kingdoms spans 1000 years of African history, allowing players to lead one of 15 unique civilizations from humble beginnings to continental dominance.

Each civilization features unique units, buildings, and technologies based on historical research. From the gold-rich Ghana Empire to the naval power of the Swahili city-states, experience Africa's rich history of kingdoms and empires.

Features:
• 15 unique African civilizations with distinct playstyles
• Campaign spanning 1000 years of African history
• Multiplayer battles up to 8 players
• Map editor with Steam Workshop support
• Historical advisor mode with educational content
• Original soundtrack featuring traditional instruments from each region`,
    image: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
    platforms: ['pc', 'playstation', 'xbox'],
    genres: ['RTS', 'Strategy', 'Historical'],
    status: 'Coming Soon',
    releaseDate: 'Q3 2025',
    rating: null,
    players: '1-8 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
  },
  {
    id: 8,
    slug: 'safari-kart',
    title: 'Safari Kart',
    tagline: 'Racing through the wild',
    description: 'Buckle up for the wildest racing experience across Africa! Race through savannas, jungles, deserts, and cities with characters inspired by African wildlife and culture.',
    longDescription: `Safari Kart brings the excitement of kart racing to the African continent. With tracks spanning from the Sahara dunes to the Cape of Good Hope, every race is a new adventure.

Choose from 24 unique racers, each with special abilities inspired by African animals and folklore. Collect power-ups, master shortcuts, and become the champion of the African Grand Prix!

Features:
• 32 unique tracks across African landscapes
• 24 playable characters with unique abilities
• Online multiplayer up to 12 players
• Split-screen local multiplayer
• Battle mode with multiple game types
• Track creator with community sharing`,
    image: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    platforms: ['pc', 'playstation', 'xbox', 'android', 'ios'],
    genres: ['Racing', 'Party', 'Multiplayer'],
    status: 'Available Now',
    releaseDate: 'Released 2024',
    rating: 4.6,
    players: '1-12 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
    downloads: '1M+',
  },
  {
    id: 9,
    slug: 'spirit-caller',
    title: 'Spirit Caller',
    tagline: 'Summon the ancestors',
    description: 'A unique card-battler where you summon ancestral spirits to battle against dark forces threatening the spirit realm. Collect over 300 cards inspired by African mythology.',
    longDescription: `In Spirit Caller, you are chosen by the ancestors to defend the barrier between worlds. Build your deck from over 300 cards representing spirits, artifacts, and powers from across African mythology.

Each card tells a story, each battle is a lesson, and every victory brings you closer to understanding the ancient wisdom of your ancestors.

Features:
• Over 300 unique cards with original artwork
• Story campaign across 8 African mythological regions
• PvP ranked ladder and tournaments
• Guild system with cooperative challenges
• Regular content updates with new cards and stories
• Free-to-play with fair monetization`,
    image: 'linear-gradient(135deg, #ec4899 0%, #be185d 100%)',
    platforms: ['android', 'ios', 'pc', 'html5'],
    genres: ['Card Game', 'Strategy', 'RPG'],
    status: 'Available Now',
    releaseDate: 'Released 2023',
    rating: 4.8,
    players: '1-2 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
    downloads: '2M+',
  },
  {
    id: 10,
    slug: 'baobab-village',
    title: 'Baobab Village',
    tagline: 'Build your African community',
    description: 'Create and manage your own African village in this relaxing life simulation. Farm, craft, trade, and build relationships with charming villagers in a beautifully stylized world.',
    longDescription: `Escape to the peaceful world of Baobab Village. Start with a small plot of land and grow it into a thriving community. Plant crops based on real African agriculture, raise livestock, and craft goods to trade with neighboring villages.

The charming villagers each have their own stories, dreams, and schedules. Build friendships, celebrate festivals, and make Baobab Village truly your own.

Features:
• Relaxing gameplay with no fail states
• Over 100 crops and animals from across Africa
• Seasonal events based on African celebrations
• Deep crafting system with 500+ items
• Villager relationship system with unique storylines
• Customizable farm and village aesthetics`,
    image: 'linear-gradient(135deg, #84cc16 0%, #65a30d 100%)',
    platforms: ['pc', 'android', 'ios'],
    genres: ['Simulation', 'Life Sim', 'Casual'],
    status: 'Available Now',
    releaseDate: 'Released 2024',
    rating: 4.9,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
    downloads: '750K+',
  },
  {
    id: 11,
    slug: 'nyama-choma-tycoon',
    title: 'Nyama Choma Tycoon',
    tagline: 'Build your food empire',
    description: 'Start from a small street food stand and build your way to a restaurant empire! Master the art of East African cuisine and become the ultimate Nyama Choma mogul.',
    longDescription: `From humble beginnings grilling meat on the streets of Dar es Salaam, build your culinary empire across East Africa. Learn authentic recipes, manage staff, and expand from a simple stand to a chain of restaurants.

Nyama Choma Tycoon celebrates East African food culture with over 100 authentic recipes and a deep management simulation that will challenge even experienced tycoon players.

Features:
• Over 100 authentic East African recipes
• Multiple locations across Tanzania, Kenya, and Uganda
• Staff management with unique character traits
• Supply chain and ingredient sourcing systems
• Competitive mode against AI restaurateurs
• Endless mode for relaxed gameplay`,
    image: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    platforms: ['android', 'ios', 'html5'],
    genres: ['Tycoon', 'Simulation', 'Management'],
    status: 'Available Now',
    releaseDate: 'Released 2024',
    rating: 4.4,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
    downloads: '300K+',
  },
  {
    id: 12,
    slug: 'lake-tanganyika',
    title: 'Lake Tanganyika',
    tagline: 'Depths of discovery',
    description: 'Dive into the world\'s second-deepest lake and discover the incredible biodiversity hidden beneath the surface. A peaceful exploration game with educational content about aquatic life.',
    longDescription: `Lake Tanganyika is home to over 300 unique fish species found nowhere else on Earth. In this peaceful exploration game, document the incredible biodiversity of the lake while uncovering the stories of the communities that depend on it.

Dive from the sunlit shallows to the mysterious depths, photograph rare species, and contribute to virtual conservation efforts.

Features:
• Scientifically accurate underwater environments
• Over 300 species to discover and document
• Relaxing gameplay with no combat or timers
• Photography mode with social sharing
• Educational content developed with marine biologists
• Stories from lakeside communities`,
    image: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
    platforms: ['pc', 'vr'],
    genres: ['Exploration', 'Educational', 'Relaxing'],
    status: 'In Development',
    releaseDate: 'Q1 2026',
    rating: null,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
  },
  {
    id: 13,
    slug: 'tinga-tinga-tales-adventure',
    title: 'Tinga Tinga Tales Adventure',
    tagline: 'Art comes to life',
    description: 'Enter a world of vibrant Tinga Tinga art in this family-friendly adventure. Help animal friends solve puzzles and learn about African wildlife in a beautifully animated world.',
    longDescription: `Inspired by the colorful Tinga Tinga art style of Tanzania, this family-friendly adventure brings African animals to life in a way never seen before in gaming.

Join Elephant, Lion, Giraffe, and friends as they solve puzzles, play mini-games, and learn about African wildlife through engaging stories and activities.

Features:
• Stunning Tinga Tinga art style throughout
• Educational content about 50+ African animals
• Age-appropriate puzzles for children 4-10
• Co-op mode for parent-child play
• No in-app purchases or advertisements
• Available in 10 African languages`,
    image: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
    platforms: ['android', 'ios', 'pc'],
    genres: ['Educational', 'Adventure', 'Family'],
    status: 'Available Now',
    releaseDate: 'Released 2023',
    rating: 4.9,
    players: '1-2 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
    downloads: '1.5M+',
  },
  {
    id: 14,
    slug: 'urban-beats-dar',
    title: 'Urban Beats: Dar',
    tagline: 'Rhythm of the city',
    description: 'A rhythm game celebrating Bongo Flava and East African music. Tap to the beat, unlock new tracks, and experience the vibrant music scene of Dar es Salaam.',
    longDescription: `Urban Beats: Dar puts you in the heart of East Africa's hottest music scene. From Bongo Flava to Taarab, experience the rhythms that make Tanzania move.

Featuring licensed tracks from top East African artists, challenge yourself to master increasingly complex rhythms while unlocking the story of a young musician's rise to fame.

Features:
• 50+ licensed tracks from top East African artists
• Multiple difficulty levels from casual to expert
• Story mode following a rising musician
• Custom track creator with community sharing
• Regular updates with new music
• Supports local music industry through revenue sharing`,
    image: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
    platforms: ['android', 'ios', 'html5'],
    genres: ['Rhythm', 'Music', 'Casual'],
    status: 'Available Now',
    releaseDate: 'Released 2024',
    rating: 4.6,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
    downloads: '400K+',
  },
  {
    id: 15,
    slug: 'serengeti-survival',
    title: 'Serengeti Survival',
    tagline: 'Live the wild life',
    description: 'Experience life as different animals in the Serengeti ecosystem. Hunt, survive, and raise your family in this realistic wildlife simulation.',
    longDescription: `Ever wondered what it's like to be a lion on the hunt, or a wildebeest protecting your herd? Serengeti Survival lets you experience the African wilderness from the animal's perspective.

Choose from 20 different species, each with unique gameplay mechanics. Experience the great migration, survive droughts, and ensure the survival of your family line.

Features:
• 20 playable animal species
• Realistic ecosystem simulation
• Seasonal changes affecting gameplay
• Family/pack management systems
• Educational mode with National Geographic content
• Documentary-style narration option`,
    image: 'linear-gradient(135deg, #78716c 0%, #57534e 100%)',
    platforms: ['pc', 'playstation', 'xbox'],
    genres: ['Simulation', 'Survival', 'Educational'],
    status: 'Coming Soon',
    releaseDate: 'Q2 2026',
    rating: null,
    players: 'Single Player',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: true,
  },
  {
    id: 16,
    slug: 'dhow-traders',
    title: 'Dhow Traders',
    tagline: 'Master the monsoon winds',
    description: 'Sail the ancient trade routes of the Indian Ocean. Build your merchant fleet, establish trade posts, and become the wealthiest trader of the Swahili coast.',
    longDescription: `Set in the golden age of Swahili trade, Dhow Traders lets you build a merchant empire spanning from the East African coast to Arabia, Persia, and beyond.

Master the monsoon winds, negotiate with sultans and merchants, and navigate the complex politics of medieval Indian Ocean trade.

Features:
• Historically accurate trade simulation
• Fleet management and ship customization
• Dynamic economy responding to player actions
• Political intrigue and diplomatic systems
• Multiplayer trading and competition
• Educational content about Swahili maritime history`,
    image: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
    platforms: ['pc'],
    genres: ['Strategy', 'Trading', 'Historical'],
    status: 'In Development',
    releaseDate: '2026',
    rating: null,
    players: '1-4 Players',
    developer: 'Riven Byte Studios',
    publisher: 'Riven Byte Studios',
    featured: false,
  },
];

export const featuredGames = gamesData.filter(game => game.featured);

export const availableGames = gamesData.filter(game => game.status === 'Available Now');

export const upcomingGames = gamesData.filter(game => 
  game.status === 'Coming Soon' || game.status === 'In Development' || game.status === 'Announced'
);

export const getGameBySlug = (slug) => gamesData.find(game => game.slug === slug);

export const getGamesByPlatform = (platform) => 
  gamesData.filter(game => game.platforms.includes(platform));

export const getGamesByGenre = (genre) => 
  gamesData.filter(game => game.genres.includes(genre));

export default gamesData;
